module.exports = __webpack_public_path__ + "assets/img/Advanced_btn.94ab3ed9.png";